// extracted by mini-css-extract-plugin
module.exports = {"createButton":"CreateComponent_createButton__2W_gS","closeButton":"CreateComponent_closeButton__1v5G8"};